/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:44 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Template = require("personalization-web-agent-templates/acdEdit.tmpl");
    var Button = require("ui/button/Button");
    var Dropdown = require("ui/dropdown/Dropdown");
    var positionsUtility = require("personalization-utils/positionsUtility");
    var KpContent = require("ui.components/kpContent/kpContent");
    var InputField = require("ui/input-field/InputField");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var Settings = require("codeTables/settings.json");
    var CONST = require("const");
    var TimeUtilities = require("utils/TimeUtilities");
    var AcdEditView;

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        AcdEditView = Marionette.ItemView.extend({
            TYPE: {
                ACD: "ACD",
                RING_FOR_ALL: "RING_FOR_ALL"
            },
            template: Template,
            className: "acd-edit anchor",
            ui: {
                cancelButton: ".cancel-edit",
                saveButton: ".save-edit",
                webChats: ".web-chats-container",
                webChatsSection: ".edit-container",
                messagingConversations: ".app-connection-title-container",
                messagingConversationsSection: ".messaging-section-container",
                appConnection: ".app-connection-container",
                appConnectionNumber: ".app-connection-number",
                appConnectionTime: ".app-connection-time",
                transferToAgentQueueTimeInput: ".transfer-to-agent-queue-number",
                transferToAgentQueueTime: ".transfer-to-agent-queue-time",
                agentTransferToQueueContainer: ".transfer-to-agent-queue-container",
                advancedModeAfterDropDown: ".radio-select .config .advanced-mode-after",
                advancedModeAgentStatusDropDown: ".radio-select .config .advanced-mode-agent-status",
                advancedModeAgentStatusConfig: ".radio-select.advancedMode .config",
                radioManualMode: ".radio .manualMode",
                radioAutoAcceptMode: ".radio .acdRadioButton.autoAcceptMode",
                radioAdvancedMode: ".radio .acdRadioButton.advancedMode",
                knowledgePack: ".kp",
                radioMessagingAutoAcceptMode: ".radio .acdMessagingRadioButton.autoAcceptMode",
                radioMessagingAdvancedMode: ".radio .acdMessagingRadioButton.advancedMode",
                messagingAdvancedModeConfig: ".radio-select.advancedMode .messaging-config",
                wrapUpContainer: ".wrap-up-time-container",
                wrapUpToggleContainer: ".wrap-up-time-toggle-container",
                wrapUpValueContainer: ".wrap-up-time-value-container",
                wrapUpInputContainer: ".wrap-up-time-input-container"

            },
            events: {
                'click .acdRadioButton': '_onSelectionChanged',
                'click .acdMessagingRadioButton': '_onMessagingSelectionChanged',
                "click .web-chats-container.field-title-collapsible": "_onWebChatsClick",
                "click .app-connection-title-container.field-title-collapsible": "_onMessagingConversationsClick"
            },
            uiComponents: {
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_cancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_save"
                    }
                },
                advancedModeAfterDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.advancedModeAfterDropDown",
                        permutation: Dropdown.PERMUTATION.DRKBG_NIGHT,
                        items: "view._getSecondsDdlCollection",
                        selectedOption: "view._getAdvancedModeAfterDropDown",
                        testCollision : true,
                        collisionWithinSelector : ".le .personalization-main-region"
                    }
                },
                advancedModeAgentStatusDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.advancedModeAgentStatusDropDown",
                        permutation: Dropdown.PERMUTATION.DRKBG_NIGHT,
                        items: new Dropdown.Collection([
                            {key: true, value: LE.translator.translate("LEPersonalization.webAgent.ACD.edt.radio.AdvancedMode.AgentStatus.dropDown.true")},
                            {key: false, value: LE.translator.translate("LEPersonalization.webAgent.ACD.edt.radio.AdvancedMode.AgentStatus.dropDown.false")}
                        ]),
                        selectedOption: "view._getAdvancedModeAgentStatusDropDown"
                    }
                },
                appConnectionTimeInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.appConnectionNumber",
                        permutation: InputField.Permutation.K,
                        theme: InputField.THEME.NIGHT,
                        maxLength: 4,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber
                    }
                },
                appConnectionTimeDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.appConnectionTime",
                        permutation: Dropdown.PERMUTATION.DRKBG_NIGHT,
                        items: new Dropdown.Collection([
                            {key: "seconds", value: LE.translator.translate("LEPersonalization.webAgent.ACD.seconds")},
                            {key: "minutes", value: LE.translator.translate("LEPersonalization.webAgent.ACD.minutes")},
                            {key: "hours", value: LE.translator.translate("LEPersonalization.webAgent.ACD.hours")}
                        ]),
                        selectedOption: "view._getAppConnectionTimeDropDown"
                    }
                },
                kpContent: {
                    type : KpContent,
                    options : {
                        container: "view.ui.knowledgePack",
                        contentPermutation: KpContent.CONTENT_PERMUTATION.INLINE,
                        KPLink: LE.translator.translate("LEPersonalization.webAgent.ACD.title.learnMore"),
                        kpID: "change-queue-options"
                    }
                }
            },

            modelEvents: {
            },
            initialize: function (options) {
                this.anchorSelector = options.anchorSelector;
                this.isMessaging = options.isMessaging;
                this.settingsCollection = options.settingsCollection;
                var subTitleTextKey = this.isMessaging ? "LEPersonalization.webAgent.ACD.text.messaging" : "LEPersonalization.webAgent.ACD.text";
                this.model.set("subtitleText", LE.translator.translate(subTitleTextKey));
            },
            customTemplateHelpers: function () {
                return {
                    showChatOptions: !LE.siteSettings.accountSettings.hideChatOptions()
                };
            },
            onRender: function () {
                var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.LEFT, positionsUtility.POSITION_Y.BOTTOM);
                this.$el.css(offset);
                this._setSelectedRadioButton();
                if(this.isMessaging) {
                    this.ui.appConnection.removeClass("hide");
                    this.ui.webChats.addClass("field-title-collapsible");
                    this.ui.webChatsSection.addClass("hide");
                    if(this.settingsCollection && this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME) && this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_ROUTING_AUTO_ACCEPT)) {
                        this.uiComponents.appConnectionTimeInput.setValue(this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME).getValue());
                        this._setMessagingSelectedRadioButton();
                    }
                    if (LE.siteSettings.accountSettings.hideChatOptions()) {
                        this.ui.messagingConversations.addClass("opened");
                        this.ui.messagingConversationsSection.removeClass("hide");
                    }
                }

                if (LE.sessionManager.hasWrapUpTimeFeature()){
                    this._renderWrapUpTime();
                    this.ui.wrapUpContainer.removeClass("hide");
                }

                if (LE.sessionManager.hasMessagingTransferToAgentFeature()) {
                    this._renderTransferToAgentBackToQueue();
                    this.ui.agentTransferToQueueContainer.removeClass("hide");
                }
            },
            onClose: function () {
            },
            _cancel: function () {
                LEPersonalization.navigateToPageMenu();
            },
            _save: function () {
                var options = {
                    type: this.type
                };
                if (this.type === this.TYPE.ACD) {
                    options.acdParams = {
                        autoAccepting: this.autoAccepting,
                        awayOnTimeout: false
                    };
                    if (!this.autoAccepting) {
                        options.acdParams.presentationTimeout= this.uiComponents.advancedModeAfterDropDown.getValue();
                        options.acdParams.awayOnTimeout = this.uiComponents.advancedModeAgentStatusDropDown.getValue();
                    }
                }

                options[Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME] = this.uiComponents.appConnectionTimeInput.getValue();
                options[Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME_UNIT] = this.uiComponents.appConnectionTimeDropDown.getValue();
                options[Settings.SETTING_ID.MESSAGING_ACD_ROUTING_AUTO_ACCEPT] = this.messagingAutoAccepting;

                if (this.uiComponents.wrapUpToggleBtn) {
                    options[Settings.SETTING_ID.WRAP_UP_TIME] = {
                        active: this.uiComponents.wrapUpToggleBtn.isChecked(),
                        time: Math.round(parseFloat(this.uiComponents.wrapUpInput.getValue()))
                    };
                }

                if (this.uiComponents.transferToAgentQueueTimeInput) {
                    var transferToAgentQueueTime = this.uiComponents.transferToAgentQueueTimeInput.getValue();
                    var transferToAgentQueueUnit = this.uiComponents.transferToAgentQueueTimeDropDown.getValue();
                    options[Settings.SETTING_ID.MESSAGING_ACD_TRANSFER_MAX_WAIT_IN_QUEUE_TIME] = TimeUtilities.convertToSeconds(transferToAgentQueueTime, transferToAgentQueueUnit);
                }

                this.trigger("acd:save", options);
            },
            isErrorView : function () {
                this.clearError();
                if(_.isEmpty(this.uiComponents.appConnectionTimeInput.getValue()) && this.isMessaging){
                    this.uiComponents.appConnectionTimeInput.setError(true, LE.translator.translate("LEPersonalization.webAgent.ACD.time.error"));
                    return true;
                }

                if (_.has(this.uiComponents, "transferToAgentQueueTimeInput")) {
                    if (_.isEmpty(this.uiComponents.transferToAgentQueueTimeInput.getValue() + '')) {
                        this.uiComponents.transferToAgentQueueTimeInput.setError(true, LE.translator.translate("LEPersonalization.webAgent.ACD.time.error"));
                        return true;
                    } else {
                        var transferToAgentQueueTime = this.uiComponents.transferToAgentQueueTimeInput.getValue();
                        var transferToAgentQueueUnit = this.uiComponents.transferToAgentQueueTimeDropDown.getValue();
                        var transferToAgentQueueInSec = TimeUtilities.convertToSeconds(transferToAgentQueueTime, transferToAgentQueueUnit);

                        if (transferToAgentQueueInSec < CONST.TRANSFER_MAX_WAIT_IN_QUEUE_TIME.MIN_ALLOWED || transferToAgentQueueInSec > CONST.TRANSFER_MAX_WAIT_IN_QUEUE_TIME.MAX_ALLOWED) {
                            this.uiComponents.transferToAgentQueueTimeInput.setError(true, LE.translator.translate("LEPersonalization.webAgent.ACD.transfer.to.agent.back.to.queue.error.label"));
                            return true;
                        }
                    }
                }

                if(_.has(this.uiComponents, "wrapUpInput") && this.uiComponents.wrapUpToggleBtn.isChecked() && this.uiComponents.wrapUpInput.getValue() === ""){
                    this.uiComponents.wrapUpInput.setError(true, LE.translator.translate("LEPersonalization.webAgent.ACD.wrapUp.error"));
                    return true;
                }
                return false;
            },
            clearError: function() {
                if (this.uiComponents.appConnectionTimeInput) {
                    this.uiComponents.appConnectionTimeInput.setError(false);
                }
                if (_.has(this.uiComponents, "wrapUpInput")) {
                    this.uiComponents.wrapUpInput.setError(false);
                }
            },
            _renderWrapUpTime: function() {
                if (!_.has(this.uiComponents, "wrapUpInput")){
                    this.uiComponents.host$.createAndRender("wrapUpInput", {
                        type: InputField,
                        options: {
                            el: "view.ui.wrapUpInputContainer",
                            permutation: InputField.Permutation.K,
                            inputType: InputField.prototype.InputTypeEnum.numbersBetweenMinToMax,
                            theme: InputField.THEME.NIGHT,
                            range: {min:CONST.WRAP_UP_TIME.MIN_VALUE, max:CONST.WRAP_UP_TIME.MAX_VALUE},
                            errorAlign: InputField.ERROR_ALIGN.LEFT,
                            value: "view._getWrapUpTime"
                        }
                    });
                }
                if (!_.has(this.uiComponents, "wrapUpToggleBtn")){
                    this.uiComponents.host$.createAndRender("wrapUpToggleBtn", {
                        type: ToggleButton,
                        options: {
                            container: "view.ui.wrapUpToggleContainer",
                            checked: "view._getIsWrapUpToggleChecked",
                            transition: ToggleButton.TRANSITION.FAST
                        },
                        events: {
                            "toggleButton:change": "_onWrapUpToggleChange"
                        }
                    });
                }
                this._showWrapUpValueContainer(!this._getIsWrapUpToggleChecked());
            },
            _renderTransferToAgentBackToQueue: function () {
                if (!_.has(this.uiComponents, "transferToAgentQueueTimeInput")) {
                    this.uiComponents.host$.createAndRender("transferToAgentQueueTimeInput", {
                        type: InputField,
                        options: {
                            el: "view.ui.transferToAgentQueueTimeInput",
                            permutation: InputField.Permutation.K,
                            inputType: InputField.prototype.InputTypeEnum.numbersBetweenMinToMax,
                            range: { min: CONST.TRANSFER_MAX_WAIT_IN_QUEUE_TIME.MIN_VALUE, max: CONST.TRANSFER_MAX_WAIT_IN_QUEUE_TIME.MAX_VALUE },
                            theme: InputField.THEME.NIGHT,
                            errorAlign: InputField.ERROR_ALIGN.LEFT,
                            value: "view._getTransferToAgentQueueInput"
                        }
                    });
                }
                if (!_.has(this.uiComponents, "transferToAgentQueueTimeDropDown")) {
                    this.uiComponents.host$.createAndRender("transferToAgentQueueTimeDropDown", {
                        type: Dropdown,
                        options: {
                            container: "view.ui.transferToAgentQueueTime",
                            permutation: Dropdown.PERMUTATION.DRKBG_NIGHT,
                            items: new Dropdown.Collection([
                                { key: "seconds", value: LE.translator.translate("LEPersonalization.webAgent.ACD.seconds") },
                                { key: "minutes", value: LE.translator.translate("LEPersonalization.webAgent.ACD.minutes") },
                                { key: "hours", value: LE.translator.translate("LEPersonalization.webAgent.ACD.hours") },
                                { key: "days", value: LE.translator.translate("LEPersonalization.webAgent.ACD.days") }
                            ]),
                            selectedOption: "view._getTransferToAgentQueueUnits"
                        }
                    });
                }
            },
            _getTransferToAgentQueueInput: function () {
                var agentToQueueInSec = this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_TRANSFER_MAX_WAIT_IN_QUEUE_TIME).getValue();
                var agentToQueueToShow = TimeUtilities.convertSecondsToOtherUnit(agentToQueueInSec);
                return agentToQueueToShow.time;
            },
            _getTransferToAgentQueueUnits: function () {
                var agentToQueueInSec = this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_TRANSFER_MAX_WAIT_IN_QUEUE_TIME).getValue();
                var agentToQueueToShow = TimeUtilities.convertSecondsToOtherUnit(agentToQueueInSec);

                return agentToQueueToShow.unit;
            },
            _getAutoAcceptAfter: function () {
                return "20";
            },
            _getAdvancedModeAfterDropDown: function () {
                return "20";
            },
            _getAdvancedModeAgentStatusDropDown: function () {
                return false;
            },
            _getAppConnectionTimeDropDown: function () {
                if(this.settingsCollection && this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME_UNIT)) {
                    return this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_RESPONSE_TIME_UNIT).getValue();
                }
            },
            _getIsWrapUpToggleChecked: function(){
                var checked = false;
                if (this.settingsCollection && this.settingsCollection.get(Settings.SETTING_ID.WRAP_UP_TIME)){
                    var wrapUpTimeObj = this.settingsCollection.get(Settings.SETTING_ID.WRAP_UP_TIME).getValue();
                    checked = wrapUpTimeObj && wrapUpTimeObj.active;
                }
                return checked;
            },
            _onWrapUpToggleChange: function(componentId, eventName, value) {
                this.uiComponents.wrapUpInput.setValue(this._getWrapUpTime());
                this._showWrapUpValueContainer(!value);
            },
            _getWrapUpTime: function() {
                var val = "";
                if (this.settingsCollection && this.settingsCollection.get(Settings.SETTING_ID.WRAP_UP_TIME)){
                    val = this.settingsCollection.get(Settings.SETTING_ID.WRAP_UP_TIME).getValue().time;
                }
                return val;
            },
            _showWrapUpValueContainer: function(show) {
                this.ui.wrapUpValueContainer.toggleClass("hide", show);
            },
            _getSecondsDdlCollection: function () {
                var options = [
                    {key: "10", value: 10},
                    {key: "20", value: 20},
                    {key: "30", value: 30},
                    {key: "40", value: 40},
                    {key: "50", value: 50},
                    {key: "60", value: 60}
                ];
                return new Dropdown.Collection(options);
            },
            _onSelectionChanged: function (event) {
                switch (event.currentTarget.value) {
                    case("manualMode"):
                        this.type = this.TYPE.RING_FOR_ALL;
                        break;
                    case("autoAcceptMode"):
                        this.type = this.TYPE.ACD;
                        this.autoAccepting=true;
                        break;
                    case("advancedMode"):
                        this.type = this.TYPE.ACD;
                        this.autoAccepting=false;
                        break;
                }
                this._setSelectedBuyType();
            },
            _onMessagingSelectionChanged: function (event) {
                this.messagingAutoAccepting = (event.currentTarget.value === "autoAcceptMode") ? true : false;
                this._displayMessagingAdvancedModeConfig();
            },
            _setSelectedBuyType: function () {
                if(this.type === this.TYPE.ACD && !this.autoAccepting){
                    this.ui.advancedModeAgentStatusConfig.removeClass("hide");
                }
                else{
                    this.ui.advancedModeAgentStatusConfig.addClass("hide");
                }
            },
            _displayMessagingAdvancedModeConfig: function () {
                this.ui.messagingAdvancedModeConfig.toggleClass("hide", this.messagingAutoAccepting);
            },
            _setSelectedRadioButton: function () {
                this.type = this.model.get("type");
                switch (this.type) {
                    case this.TYPE.ACD:
                        this.autoAccepting = this.model.get("acdParams.autoAccepting");
                        var presentationTimeout = this.model.get("acdParams.presentationTimeout");
                        if (this.autoAccepting) {
                            this.ui.radioAutoAcceptMode.attr("checked", true);
                        }
                        else {
                            var awayOnTimeout = this.model.get("acdParams.awayOnTimeout");
                            this.ui.radioAdvancedMode.attr("checked", true);
                            this.uiComponents.advancedModeAfterDropDown.setSelection(presentationTimeout.toString());
                            this.uiComponents.advancedModeAgentStatusDropDown.setSelection(awayOnTimeout);
                        }
                        break;
                    case this.TYPE.RING_FOR_ALL:
                        this.ui.radioManualMode.attr("checked", true);
                        break;
                }
                this._setSelectedBuyType();
            },
            _setMessagingSelectedRadioButton: function () {
                this.messagingAutoAccepting = (this.settingsCollection && this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_ROUTING_AUTO_ACCEPT)) ? (this.settingsCollection.get(Settings.SETTING_ID.MESSAGING_ACD_ROUTING_AUTO_ACCEPT).getValue() === "true") : false;
                if (this.messagingAutoAccepting) {
                    this.ui.radioMessagingAutoAcceptMode.attr("checked", this.messagingAutoAccepting);
                } else {
                    this.ui.radioMessagingAdvancedMode.attr("checked", !this.messagingAutoAccepting);
                }
                this._displayMessagingAdvancedModeConfig();
            },
            _onWebChatsClick: function () {
                this.ui.webChats.toggleClass("opened");
                this.ui.webChatsSection.toggleClass("hide");
            },
            _onMessagingConversationsClick: function () {
                this.ui.messagingConversations.toggleClass("opened");
                this.ui.messagingConversationsSection.toggleClass("hide");
            }

        });
    });
    return AcdEditView;

});

